import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-previously-bought-badge',
  templateUrl: './previously-bought-badge.component.html',
  styleUrls: ['./previously-bought-badge.component.scss'],
  standalone: false,
})
export class PreviouslyBoughtBadgeComponent {
  @Input() inverted = false;
}
